/* eslint-disable no-restricted-globals */
export const isLocal = () =>
  location.hostname === "localhost" ||
  location.hostname === "127.0.0.1" ||
  location.hostname.includes("192.168");

// Both apps read their environment from the host: layout's sites are genfive-{env}, the admin's
// genfive-admin-{env} (GEN5-5269: one env module for both apps).
export const isDev = () =>
  location.hostname.includes("genfive.dev") ||
  location.hostname.includes("genie.dev") ||
  location.hostname.includes("genfive-dev") ||
  location.hostname.includes("genfive-admin-dev");

export const isUat = () =>
  location.hostname.includes("genfive.uat") ||
  location.hostname.includes("genie.uat") ||
  location.hostname.includes("genfive-uat") ||
  location.hostname.includes("genfive-admin-uat");

export const isProd = () =>
  location.hostname.includes("genfive.tsc") ||
  location.hostname.includes("genie.tsc") ||
  location.hostname.includes("genfive-prod") ||
  location.hostname.includes("genfive-admin-prod");

export const backendAddress = () => {
  if (isLocal() && !!import.meta.env.REACT_APP_BACKEND_URL)
    return import.meta.env.REACT_APP_BACKEND_URL;
  if (isLocal()) return "http://localhost:8080";
  if (isDev()) return "https://api.genfive.dev.tsc.ai";
  if (isUat()) return "https://api.genfive.uat.tsc.ai";
  return "https://api.genfive.tsc.ai";
};

/**
 * chat-service's address: a local one when running locally with
 * REACT_APP_CHAT_SERVICE_URL (e.g. http://localhost:8087, see
 * workspace-setup/README.md, "Settings"), so Genie can be tested end to end on a laptop while
 * every other service stays on the backend address.
 */
export const chatServiceAddress = () =>
  isLocal() && import.meta.env.REACT_APP_CHAT_SERVICE_URL
    ? import.meta.env.REACT_APP_CHAT_SERVICE_URL
    : backendAddress();

/** The client app (layout) an admin page links to. */
export const getClientPortalDomain = () => {
  if (isLocal() && !!import.meta.env.REACT_APP_CLIENT_PORTAL_DOMAIN)
    return import.meta.env.REACT_APP_CLIENT_PORTAL_DOMAIN;
  if (isLocal()) return "http://localhost:3000";
  if (isDev()) return "https://genie.dev.tsc.ai";
  if (isUat()) return "https://genie.uat.tsc.ai";
  return "https://genie.tsc.ai";
};

export const getEnvironment = () => {
  if (isProd()) return "production";
  if (isUat()) return "uat";
  if (isDev()) return "development";
  if (isLocal()) return "local";
  return undefined;
};

export const googleCalendarOAuthClientId = () => {
  if (import.meta.env.REACT_APP_GOOGLE_CALENDAR_OAUTH_CLIENT_ID) {
    return import.meta.env.REACT_APP_GOOGLE_CALENDAR_OAUTH_CLIENT_ID;
  }
  if (isLocal() || isDev() || isUat()) {
    return "392418037072-eh5k9qvklhpnlgg0g65e52uqgvn0fkjv.apps.googleusercontent.com";
  }
  // NOTE: Reuse the same client id for convenience, we might want to create a separate one for prod in the future
  return "392418037072-eh5k9qvklhpnlgg0g65e52uqgvn0fkjv.apps.googleusercontent.com";
};

export const microsoftCalendarOAuthClientId = () => {
  if (isProd()) {
    return "e3fa2d57-d8a2-408e-9d60-7643113c4899";
  }
  return "254aa61c-36ae-4778-b93e-f95cd79d1585";
};

export const microsoftCalendarOAuthTenant = () =>
  import.meta.env.REACT_APP_MICROSOFT_CALENDAR_OAUTH_TENANT || "common";

export const isSafari = /^((?!chrome|android).)*safari/i.test(
  navigator.userAgent
);
export const isFirefox =
  navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
export const isEdge = document.documentMode || /Edge/.test(navigator.userAgent);

export const getRedirectPath = () =>
  `${window.location.pathname ?? ""}
  ${window.location.search ?? ""}
  ${window.location.hash ?? ""}`;

export const bounded = (num, min, max) => Math.min(Math.max(num, min), max);

export const isE2E_Org = (organizationId) =>
  ((isDev() || isLocal()) && organizationId === "81") ||
  (isUat() && organizationId === "18") ||
  (isProd() && organizationId === "54");

// Workspaces on dev and uat where we test client-specific custom developments before
// they reach the client's org on prod.
// Tickets: https://tsclabs.atlassian.net/browse/ESUP-2044 (COPA),
// https://tsclabs.atlassian.net/browse/GEN5-5100 (DP World)
export const isCustomDevTestingWorkspace = (workspaceId) =>
  // Tra demo project on dev
  ((isDev() || isLocal()) && String(workspaceId) === "10") ||
  // Cindy test project on uat
  (isUat() && String(workspaceId) === "147");

export const isFakeRequestNewStakeholderEnabled = () => {
  const rawValue =
    import.meta.env.REACT_APP_FAKE_REQUEST_NEW_STAKEHOLDER?.toLowerCase() ?? "";
  return (
    (isLocal() || isDev()) && ["1", "true", "yes", "on"].includes(rawValue)
  );
};
